import {z} from 'zod';

import i18n from '@dms/i18n';

import {getApiDateString} from 'shared/web';

export const AUCTION_TYPES = ['auction', 'auction_buy_now', 'buy_now_only'] as const;

const isFilled = (html: string | null) => (html ?? '').replace(/<[^>]*>/g, '').trim() !== '';

export function listingSchema(minMileage: number) {
  const today = getApiDateString(new Date());
  const titleMessage = i18n.t('entity.auction.validation.title');
  return z.object({
    type: z.enum(AUCTION_TYPES),
    // A cleared input gives null, so the type error also needs the auction message.
    title: z
      .string({required_error: titleMessage, invalid_type_error: titleMessage})
      .trim()
      .min(1, titleMessage),
    description: z
      .string()
      .nullable()
      .refine(isFilled, i18n.t('entity.auction.validation.description')),
    inspectionId: z
      .string()
      .nullable()
      .refine((id) => id !== null, i18n.t('entity.auction.validation.inspection')),
    estimatedAvailabilityAt: z
      .string()
      .nullable()
      .refine(
        (date) => date !== null && date >= today,
        i18n.t('entity.auction.validation.availability')
      ),
    estimatedMileage: z
      .number()
      .nullable()
      .refine(
        (km) => km !== null && Number.isInteger(km) && km >= minMileage,
        i18n.t('entity.auction.validation.mileage', {km: minMileage})
      ),
    collectionSiteId: z.string().nullable(),
    publicNote: z.string().nullable(),
    internalNote: z.string().nullable(),
  });
}

export type ListingFormValues = z.infer<ReturnType<typeof listingSchema>>;
